import { Grid, Typography, TextField, Paper, Box, Button } from '@mui/material';
import ImageGrid from '../ImageGrid/ImageGrid';
import newsletterImage from '../../../assets/StoriesPage/NewsletterPlane.svg';
import { useNavigate } from 'react-router-dom';
import React from 'react';
import { useFormik } from 'formik';
import * as yup from 'yup';

const validationSchema = yup.object({
  firstName: yup.string('Enter your first name').required('First name is required'),
  email: yup.string('Enter your email').email('Enter a valid email').required('Email is required'),
});

const SubscribeSection = (props) => {
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: {
      email: '',
      firstName: '',
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      if (props.setTrigger) {
        props.setTrigger();
      }
      updateContactSendGrid(values.firstName, values.email);
      slackNotification(values.firstName, values.email);
      navigate(`/joinEmail`);
    },
  });

  const updateContactSendGrid = async (nameValue, emailValue) => {
    const welcomeEmail = {
      to: emailValue,
      from: 'hello@the100club.io', // Change to your verified sender
      subject: `The 100 Club: You're subscribed!`,
      html: `Hey ${nameValue},<br>Thank you for subscribing to our newsletter. You're officially a Friend of The 100 Club!</a>.`,
    };
    const url = 'https://w3wg3dmosqeep4crte5btpm5pa0sdnjh.lambda-url.us-east-1.on.aws/';
    const data = {
      email: emailValue,
      firstName: nameValue,
      msg: JSON.stringify(welcomeEmail),
    };
    try {
      const res = await fetch(url, {
        method: 'POST',
        headers: {},
        body: JSON.stringify(data),
      });
      console.log(res);
    } catch (error) {
      console.log(error);
    }
  };

  const slackNotification = async (firstName, email) => {
    const url = 'https://hooks.slack.com/services/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';
    const data = {
      text: `${firstName} from ${email} just signed up for our newsletter. Awesome stuff!`,
    };

    // eslint-disable-next-line
    let res = await fetch(url, {
      method: 'POST',
      headers: {
        Accept: 'application/json, text/plain, */*',
      },
      body: JSON.stringify(data),
    });
  };

  return (
    <Grid
      xs={12}
      lg={props.variant === 'popup' || props.variant === 'flat' ? 12 : 6}
      item
      justifyContent='center'
      alignItems='center'>
      <Paper
        elevation={props.variant === 'popup' ? 0 : 20}
        sx={{
          align: 'center',
          margin: { md: '3rem' },
          padding: { xs: '2rem', sm: props.variant === 'popup' ? '0' : '3rem' },
          borderRadius: 5,
        }}>
        <Grid container direction='column' alignItems='center' justifyContent='center'>
          <Grid item>
            <ImageGrid gridSize={12} src={newsletterImage} alt={'Newsletter Plane'} maxWidth={{ maxWidth: '250px' }} />
          </Grid>

          <Grid item>
            <Typography item variant='h4'>
              <Box sx={{ textAlign: 'center', fontWeight: 'bold', mt: '1rem' }}>Subscribe to our newsletter </Box>
            </Typography>
          </Grid>
          <Grid item>
            <Typography item variant='body1'>
              <Box sx={{ textAlign: 'center', fontSize: 18, mt: '1rem' }}>
                Become a Friend of The 100 Club! Get founder case studies + early access to our unique monthly
                networking events, delivered directly to your inbox.
              </Box>
            </Typography>
          </Grid>
          <form onSubmit={formik.handleSubmit}>
            <Grid
              container
              direction='column'
              spacing={2}
              sx={{
                justifyContent: 'center',
                alignItems: 'center',
              }}>
              <TextField
                id='firstName'
                name='firstName'
                label='First Name'
                type='firstName'
                variant='filled'
                size='small'
                sx={{
                  color: 'primary',
                  mt: '2rem',
                }}
                value={formik.values.firstName}
                onChange={formik.handleChange}
                error={formik.touched.firstName && Boolean(formik.errors.firstName)}
                helperText={formik.touched.firstName && formik.errors.firstName}
              />
              <TextField
                id='email'
                name='email'
                variant='filled'
                size='small'
                label='Email Address'
                sx={{
                  color: 'primary',
                  mt: '1rem',
                }}
                value={formik.values.email}
                onChange={formik.handleChange}
                error={formik.touched.email && Boolean(formik.errors.email)}
                helperText={formik.touched.email && formik.errors.email}
              />
              <Grid item>
                <Button
                  color='primary'
                  variant='contained'
                  fullWidth
                  type='submit'
                  sx={{
                    fontFamily: 'Montserrat',
                    backgroundColor: 'var(--highlight)',
                    fontWeight: 'bold',
                    color: '#ffffff',
                    textDecoration: 'none',
                    padding: '0.5rem 2rem',
                    fontSize: '1rem',
                    transition: '0.2s ease-out',
                    borderRadius: '10px',
                    border: 'none',
                    cursor: 'pointer',
                    outline: 'inherit',
                  }}>
                  Submit
                </Button>
              </Grid>
            </Grid>
          </form>
        </Grid>
      </Paper>
    </Grid>
  );
};

export default SubscribeSection;
